<div
  class="columns is-mobile is-centered is-vcentered is-full-height-with-navbar"
  [ngClass]="{ 'is-full-height-with-navbar-table-container': tableContainer }"
>
  <div
    class="column is-full-mobile is-10-tablet is-one-third-desktop content"
    *ngIf="!tableContainer"
  >
    <h2 class="title is-3" data-e2e="title">
      {{ title }}
    </h2>
    <p data-e2e="description">
      {{ description }}
    </p>
    <ng-content></ng-content>
  </div>
  <div
    class="column is-full-mobile is-10-tablet is-one-third-desktop columns is-mobile is-centered message-box"
    *ngIf="tableContainer"
  >
    <div class="column is-1" [ngStyle]="{ 'font-size': iconFontSize }" *ngIf="iconSearchVisible">
      <span class="icon is-small is-left">
        <i class="fa fa-search"></i>
      </span>
    </div>
    <div class="column ml-2" [ngStyle]="{ 'font-size': descriptionFontSize }">
      <p data-e2e="description" [innerHtml]="description"></p>
    </div>
  </div>
</div>
